import React from 'react';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import LinkCreatedCard from '../RequestChecklist/LinkCreatedCard';

export default function ExternalLinkCreatedModal({ open, link, onClose }) {
  if (!open) return null;

  return (
    <div
      role="presentation"
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 2500,
        background: 'rgba(15, 23, 42, 0.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="external-link-created-title"
        onClick={(event) => event.stopPropagation()}
        style={{
          width: '100%',
          maxWidth: 720,
          borderRadius: 16,
          background: '#FFFFFF',
          padding: 22,
          boxShadow: '0 24px 60px rgba(15, 23, 42, 0.24)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 18 }}>
          <div
            id="external-link-created-title"
            style={{ flex: 1, fontSize: 18, fontWeight: 700, color: '#111827' }}
          >
            Link externo do checklist
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Fechar"
            style={{ border: 0, background: 'transparent', padding: 4, cursor: 'pointer' }}
          >
            <CloseOutlinedIcon style={{ fontSize: 20, color: '#4B5563' }} />
          </button>
        </div>

        <LinkCreatedCard link={link} onClose={onClose} />
      </div>
    </div>
  );
}
